module.exports = __webpack_public_path__ + "img/avatar0.f9199305.png";